import { OfferWrapper, Provider } from 'generated/api'
import { buildSearchHistoryBlocks, LoanOfferCardBlocks } from 'components/domain/search/offers/loans/builder'
import { truncArray } from 'lib'
import { Pending, PendingStatus } from 'components/patterns/suspense/internals/types'
import { Actionable, Button, Card, Dismissible, Icon, Modal, Text, useToggle, View } from 'reshaped/bundle'
import { RightArrowIcon } from 'shared/icons/RightArrowIcon'
import {
	dismissible,
	generatedHTMLClassname
} from 'components/domain/search/offers/loans/LoanOfferCard/LoanOfferCard.css'

interface LoanOfferProps {
	offer: OfferWrapper
	provider: Provider
	onClick: () => void
}

export const LoanOffer: React.FC<React.PropsWithChildren<Pending<LoanOfferProps>>> = props => (
	<SearchHistoryOfferCard {...buildSearchHistoryBlocks(props)} />
)

export const SearchHistoryOfferCard: React.FC<React.PropsWithChildren<LoanOfferCardBlocks>> = ({
	ribbon,
	trivia,
	image,
	disclosure,
	status,
	onClick
}) => {
	const { active, activate, deactivate } = useToggle(false)
	const isContentLoaded = status === PendingStatus.complete
	const triviaRest = truncArray(trivia, 3)

	return (
		<Card padding={0}>
			{ribbon}
			<View padding={4} direction="row" gap={6}>
				<View gap={2} maxWidth={28}>
					{image}
					{isContentLoaded && (
						<Actionable onClick={activate}>
							<Text color="neutral-faded" attributes={{ style: { textDecoration: 'underline' } }}>
								Info &amp; Disclaimer
							</Text>
						</Actionable>
					)}
				</View>
				<View.Item grow>
					<View direction="row" gap={6} wrap={false}>
						{triviaRest}
						<Button onClick={onClick} color="positive" size="large">
							<Icon svg={RightArrowIcon} size={5} />
						</Button>
					</View>
				</View.Item>
			</View>
			<Modal active={active} onClose={deactivate} size="950px">
				<Dismissible onClose={deactivate} closeAriaLabel="Close modal" className={dismissible}>
					<View gap={4}>
						<View
							direction={{ m: 'row' }}
							align={{ s: 'baseline', m: 'center' }}
							gap={{ s: 6, xl: 10 }}
							paddingEnd={{ m: 6 }}
						>
							<View.Item grow={{ s: true, m: false }}>{image}</View.Item>

							<View.Item grow columns={{ s: 12, m: 9 }}>
								<View direction="row" attributes={{ style: { justifyContent: 'space-between', width: '100%' } }}>
									{triviaRest}

									<Button onClick={onClick} color="positive" size="large">
										<Icon svg={RightArrowIcon} size={5} />
									</Button>
								</View>
							</View.Item>
						</View>

						<div className={generatedHTMLClassname}>{disclosure}</div>
					</View>
				</Dismissible>
			</Modal>
		</Card>
	)
}
